import React from "react";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import isMobile from "ismobilejs";

const browserStyles = theme => {
  return {
    dialogContent: {
      width: 700
    },
    label: {
      padding: "0 15px 3px 7px",
      borderBottom: `2px solid ${theme.palette.answer.borderColor}`
    },
    buttonsDiv: {
      marginTop: 20
    },
    itemBtn: {
      margin: 10,
      padding: "8px 15px"
    },
    itemBtnRaised: {
      backgroundColor: theme.palette.answer.dark,
      "&:hover": {
        backgroundColor: theme.palette.answer.light,
        boxShadow: "2px 3px 7px rgba(0,0,0,0.4);"
      }
    },
    selectedItemBtnRaised: {
      backgroundColor: theme.palette.answer.light,
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);",
      "&:hover": {
        backgroundColor: theme.palette.answer.light
      }
    }
  };
};

const mobileStyles = theme => {
  return {
    dialogTitle: {
      padding: 10
    },
    dialogContent: {
      padding: 10
    },
    label: {
      padding: 2,
      borderBottom: `2px solid ${theme.palette.answer.borderColor}`
    },
    buttonsDiv: {
      marginTop: 10,
      display: "grid"
    },
    itemBtn: {
      margin: 5,
      padding: 7,
      fontSize: "1.1rem"
    },
    itemBtnRaised: {
      backgroundColor: theme.palette.answer.dark,
      "&:hover": {
        backgroundColor: theme.palette.answer.light,
        boxShadow: "2px 3px 7px rgba(0,0,0,0.4);"
      }
    },
    selectedItemBtnRaised: {
      backgroundColor: theme.palette.answer.light,
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);",
      "&:hover": {
        backgroundColor: theme.palette.answer.light
      }
    },
    dialogActions: {
      margin: 0
    }
  };
};

const AdditionEditDialog = props => {
  const { classes, additionEditDialog } = props;
  const { open, addition, selectedChoice } = additionEditDialog;
  const { qNo, text, choices } = addition;
  const { handleSelect, handleSubmit, handleClose } = props; // action

  return (
    <Dialog open={open}>
      <DialogTitle className={classes.dialogTitle}>回答の編集</DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <div>
          <span className={classes.label}>{`${qNo}. ${text}`}</span>
        </div>

        <div className={classes.buttonsDiv}>
          {choices.map(choice => (
            <Button
              key={choice.id}
              raised
              dense
              onClick={handleSelect(choice)}
              className={classes.itemBtn}
              classes={{
                raised:
                  choice.id === selectedChoice.id
                    ? classes.selectedItemBtnRaised
                    : classes.itemBtnRaised
              }}
            >
              {choice.label}
            </Button>
          ))}
        </div>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button raised={!isMobile.any} onClick={handleClose}>
          キャンセル
        </Button>

        <Button
          raised={!isMobile.any}
          onClick={handleSubmit(addition, selectedChoice)}
        >
          決定
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AdditionEditDialog
);



// WEBPACK FOOTER //
// ./src/components/answer/AdditionEditDialog.jsx